import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* getLookbookOrderItem({ payload: { signal, id, orderId, itemId, onSuccess } }) {
  try {
    const { data } = yield call(fetch, { api: api.lookbooks.orders.items.get, pathParams: { id, orderId, itemId }, signal });

    onSuccess && onSuccess(data.result);
    yield put(actions.getLookbookOrderItemDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getLookbookOrderItemFailed,
      endpoint: api.lookbooks.orders.items.get.url
    });
  }
}

export const getLookbookOrderItemSaga = takeEvery(types.GET_LOOKBOOK_ORDER_ITEM_REQUEST, getLookbookOrderItem);